import HttpClientToken from '../../services/HttpClientToken';

import { TipoTramiteProps, defaultTipoTramite } from '../../interfaces/catalogos/TipoTramiteInterface';

export const TiposTramite = () => {

    return new Promise<TipoTramiteProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoTramite/', token)
            .then( ({ data } : { data : TipoTramiteProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoTramites = () => {

    return new Promise<TipoTramiteProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoTramite/ObtenerTipoTramites', token)
            .then( ({ data } : { data : TipoTramiteProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoTramite = ( params: TipoTramiteProps ) => {

    return new Promise<TipoTramiteProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoTramite/Actualizar', params, token)
            .then( ({ data } : { data : TipoTramiteProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoTramite } );
            });

        }

    });

}

export const AgregarTipoTramite = ( params: TipoTramiteProps ) => {

    return new Promise<TipoTramiteProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoTramite/Agregar', params, token)
            .then( ({ data } : { data : TipoTramiteProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoTramite } );
            });

        }

    });

}
